class KpiController extends BaseController
	@register angular.module 'App.Module.Controller'
	@inject '$scope',
		'UserInformation'
		'ReportService'
		'CurrencyRepository'
		'UserShopRepository'
		'BACKEND_ORDERS_ANALYTICS_QUERY_TYPE'

	initialize: ->
		@$scope.startTime = moment().subtract(30, 'days').unix()
		@$scope.endTime = moment().unix()
		@$scope.currency = @UserInformation.getMasterUser().currency

		@getData()

	getData: ->
		@$scope.turnover = @$scope.quantity = @$scope.grossMargin = @$scope.basketQuantity = @$scope.basketSize = 0

		reports = [
			@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.TURNOVER,
			@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.QUANTITY,
			@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.GROSS_MARGIN,
			@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.AVERAGE_BASKET_QUANTITY,
			@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.AVERAGE_BASKET_SIZE,
			@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.ORDER_COUNT,
		]

		@$scope.loading = true

		@ReportService
			.getOrdersAnalytics(
				@$scope.startTime,
				@$scope.endTime,
				@$scope.currency,
				true,
				true,
				null,
				@$scope.shopId,
				reports,
			)
			.then (results) =>
				@$scope.loading = false
				@$scope.turnover = results[@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.TURNOVER]
				@$scope.quantity = results[@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.QUANTITY]
				@$scope.grossMargin = results[@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.GROSS_MARGIN]
				@$scope.basketQuantity = results[@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.AVERAGE_BASKET_QUANTITY]
				@$scope.basketSize = results[@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.AVERAGE_BASKET_SIZE]
				@$scope.ordersCount = results[@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.ORDER_COUNT]

	searchCurrencies: (query) ->
		return @CurrencyRepository
			.findByQuery(query)
			.then (response) -> response.data
			.then (currencies) -> _.map(
				currencies,
				(currency) -> {
					currency...
					currency_name: "#{currency.currency_name} (#{currency.iso})"
				},
			)

	onCurrencyChange: () ->
		@getData()

	searchShops: (query) ->
		query.with('price_region')

		return @UserShopRepository
			.findByQuery(query)
			.then (response) -> response.data

	onShopChange: (shop) ->
		@$scope.currency = shop?.price_region?.currency ? @$scope.currency
		@getData()

